// extracted by mini-css-extract-plugin
module.exports = {"nome-destinatario":"Registro_nome-destinatario__RY1Dm","corpo-texto":"Registro_corpo-texto__156W8"};